/* The name of this component is a little misleading. 
It should actually be two separate components, and in a later iteration of the Cend code, it will be.
One component displays all users on the system as possible send participants (this is on the bottom since it might be lengthy).
It is this piece that gives the overall component its name.
Ideally it would allow for paging and searching so that there is not just one gigantic list.
The other piece, which should be a separate component, is the sendlist.
The sendlist only displays users with whom a send conversation already exists.
There is a huge bug right now, in that the sendlist does not properly display when a new message from the other party has arrived.
We are working on it. A few variations have already been tried. */

import React, { Component } from "react";
import PropTypes from "prop-types";


class Userslocal extends Component {

    constructor(props, context){
        super(props, context);
        this.handleCurrentUserClick = this.handleCurrentUserClick.bind(this);
    }

    handleCurrentUserClick(data){
        this.props.pwSetCurrentSendUser(data.eachuser);
    }

    render() {
        var boolTokenSet = false;
        
        if((sessionStorage.getItem("token") && sessionStorage.getItem("token") !== "-1")){
            boolTokenSet = true;
        }

        if(boolTokenSet){
            if((this.props.userlist.length === 0) && (this.props.sendlist.length === 0)){
                return(<div class="sidebar"></div>);
            }
            else{

                function DisplayDate(dateString){
                    var date = new Date(dateString);
                    var nowdate = new Date();
                    var startdate = new Date("1970");
                    nowdate.setHours(0,0,0,0);
                    /* If the date is greater than the beginning of today, just diplay hour */
                    if(date < startdate){
                        return "Never";
                    }
                    else if(nowdate > date){
                        return date.toDateString();
                    }
                    else{
                        return date.toLocaleTimeString();
                    }

                }
                /* https://stackoverflow.com/questions/1416296/parsing-a-date-in-long-format-from-atom-feed */
                function AtomDateToJavascriptDate(datestr) {
                    var yy   = datestr.substring(0,4);
                    var mo   = datestr.substring(5,7);
                    var dd   = datestr.substring(8,10);
                    var hh   = datestr.substring(11,13);
                    var mi   = datestr.substring(14,16);
                    var ss   = datestr.substring(17,19);
                    var tzs  = datestr.substring(19,20);
                    var tzhh = datestr.substring(20,22);
                    var tzmi = datestr.substring(23,25);
                    var myutc = Date.UTC(yy-0,mo-1,dd-0,hh-0,mi-0,ss-0);
                    var tzos = (tzs+(tzhh * 60 + tzmi * 1)) * 60000;
                    return new Date(myutc-tzos);
                    }

                var sendlistdisplay = '';
                if(Array.isArray(this.props.sendlist)){
                    {sendlistdisplay = this.props.sendlist.map(sendlistuser =>{
                        var eachuser = sendlistuser.name
                        var newindicator = ''
                        var inboundSentDate = AtomDateToJavascriptDate(sendlistuser.othersenddate)
                        var inboundseenDate = AtomDateToJavascriptDate(sendlistuser.selfseen)
                        var outboundSentDate = AtomDateToJavascriptDate(sendlistuser.selfsenddate)
                        var outboundseenDate = AtomDateToJavascriptDate(sendlistuser.otherseen)
                        if(inboundSentDate > inboundseenDate ){
                             newindicator = ' *NEW*'
                        }
                        var lastmessagedate = sendlistuser.othersenddate;
                        if(AtomDateToJavascriptDate(sendlistuser.selfsenddate) > AtomDateToJavascriptDate(sendlistuser.othersenddate)){
                            lastmessagedate = sendlistuser.selfsenddate;
                        }
                         return(
                         <li><a href="javascript:void(0)" key={sendlistuser.name} onClick={this.handleCurrentUserClick.bind(null,{eachuser})}>{sendlistuser.name}</a> {DisplayDate(lastmessagedate)}{newindicator}</li>)}
                     )}
                }
                return ( <div class="sidebar">
                           <div class="watchlist">
                           <span>Send List</span>
                           <ul>
                            {sendlistdisplay}
                          </ul></div>
                            <div class="watchlist">
                            <span>All Users</span>
                            <ul>
                                {this.props.userlist.map(eachuser =>{
                                    return(
                                    <li><a href="javascript:void(0)" key={eachuser} onClick={this.handleCurrentUserClick.bind(null,{eachuser})}>{eachuser}</a></li>)}
                                )}
                            </ul></div>
                            </div>)
            }
        }
        else{
            return(<div class="sidebar"></div>);
        }
    }

}

Userslocal.PropTypes = {
    userlist: PropTypes.array.isRequired,
    sendlist: {
        name: PropTypes.string.isRequired,
        selfsenddate: PropTypes.string.isRequired,
        selfseen: PropTypes.string.isRequired,
        othersenddate: PropTypes.string.isRequired,
        otherseen: PropTypes.string.isRequired,
    }
}

export default Userslocal;


// WEBPACK FOOTER //
// ./src/Userslocal.js